import React from "react";
import { useLocation } from "react-router-dom";
import BreadcrumbItem from "./BreadcrumbItem";
import { FrontEndRoutes } from "../config/front-end-routes";
import useBreadcrumbs from "../config/useBreadcrumbs";

const Breadcrumb: React.FC = () => {
    const location = useLocation();
    const breadcrumbs = useBreadcrumbs(location.pathname, FrontEndRoutes);

    return (
        <nav
            className="d-flex  justify-content-end text-end m-0"
            style={{ "--bs-breadcrumb-divider": "' / '" } as React.CSSProperties}
            aria-label="breadcrumb"
        >
            <ol className="breadcrumb text-end p-2 m-0">
                {breadcrumbs.map((breadcrumb, index) => (
                    <BreadcrumbItem
                        key={index}
                        breadcrumb={breadcrumb}
                        isLast={index === breadcrumbs.length - 1}
                    />
                ))}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
